// extracted by mini-css-extract-plugin
export var centerText = "_5f-8";
export var container = "_5f-0";
export var doughnutContainer = "_5f-7";
export var legend = "_5f-a";
export var legendItemColorDisplay = "_5f-b";
export var legendItemLabel = "_5f-d";
export var legendItemValue = "_5f-c";
export var lg = "_5f-5";
export var maxWidth = "_5f-9";
export var md = "_5f-4";
export var responsive = "_5f-6";
export var sm = "_5f-3";
export var xs = "_5f-2";
export var xxs = "_5f-1";